(function () {
  if (window.__configuratorUpgradesInit) return;
  window.__configuratorUpgradesInit = true;

  function syncCardState(card) {
    var qtyInput = card.querySelector('.addon-quantity');
    if (!qtyInput) return;
    var qty = parseInt(qtyInput.value, 10) || 0;
    card.classList.toggle('is-selected', qty > 0);
    var toggle = card.querySelector('.configurator-upgrade-card__toggle');
    if (toggle) toggle.setAttribute('aria-pressed', qty > 0 ? 'true' : 'false');
  }

  document.addEventListener('click', function (e) {
    // Stepper buttons: product-addon.js already has its own delegated click
    // listener on document that increments/decrements the adjacent
    // .addon-quantity input's value directly (synchronously, no change
    // event fired). Let that run first, then resync this card's
    // selected/checkmark visuals on the next tick so order between the two
    // scripts' listeners never matters.
    if (e.target.classList.contains('qty-plus') || e.target.classList.contains('qty-minus')) {
      var stepperCard = e.target.closest('.configurator-upgrade-card');
      if (stepperCard) {
        window.setTimeout(function () {
          syncCardState(stepperCard);
        }, 0);
      }
      return;
    }

    var toggle = e.target.closest('.configurator-upgrade-card__toggle');
    if (!toggle) return;
    e.preventDefault();

    var card = toggle.closest('.configurator-upgrade-card');
    if (!card) return;

    var qtyInput = card.querySelector('.addon-quantity');
    if (!qtyInput) return;

    // Quick shortcut: clicking the image/title/price area adds one unit if
    // none are selected yet, or clears the quantity entirely if any are
    // selected. Fine-grained 2/3/etc. control lives in the +/- stepper.
    var currentQty = parseInt(qtyInput.value, 10) || 0;
    qtyInput.value = currentQty > 0 ? 0 : 1;
    qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    syncCardState(card);
  });

  // On mobile, the legacy reorder stylesheet (templates/product.json custom
  // liquid) leaves "Free Swatch" nested inside .m-product-form--wrapper
  // (order:1) -- the same wrapper as the model/fabric pickers and the Add to
  // Cart button -- instead of giving it its own order. That makes it render
  // above Check Dimensions/Addons on mobile instead of after them. Clone it
  // out into a dedicated order:7 wrapper (see configurator.css .swatch-mob,
  // right after .dims-mob's order:6) so it visually lands right after Check
  // Dimensions, and hide the original so there's only ever one visible copy.
  function isMobileWidth() {
    return window.innerWidth <= 768;
  }

  function moveSwatchAfterDims() {
    if (!isMobileWidth()) return;
    var form = document.querySelector('product-form form');
    if (!form) return;
    if (form.querySelector('.swatch-mob')) return;

    var original = form.querySelector('.product-swatches-button');
    if (!original || original.dataset.swatchMobHidden === 'true') return;

    var wrap = document.createElement('div');
    wrap.className = 'swatch-mob';
    wrap.appendChild(original.cloneNode(true));
    form.appendChild(wrap);

    original.dataset.swatchMobHidden = 'true';
    original.style.display = 'none';
  }

  document.addEventListener('DOMContentLoaded', moveSwatchAfterDims);
  document.addEventListener('theme:section:reload', moveSwatchAfterDims);
  if (document.readyState !== 'loading') moveSwatchAfterDims();
})();
